import React from 'react';

import { DropdownWrapper, IconFile } from '@trqk/components';

import { width, height } from './constants';

interface StatementSelectorPreviewProps {
    label: string;
}

/**
 * Provides the ability to select one or more statements for viewing, based on the current user and
 * currently selected entity. Statement selection is available through several preset values,
 * including "All Statements" and "Year to Date". Statements can also be selected one by one,
 * although the user must select a contiguous date range of statements when doing this.
 * @param Props props sourced from the useStatementSelection hook
 */
export const StatementSelectorPreview = ({
    label,
}: StatementSelectorPreviewProps): JSX.Element => (
        <DropdownWrapper
            disabled={true}
            boxShadowWhenClosed={true}
            boxShadowWhenOpen={true}
            size="medium"
            isExpanded={false}
            setIsExpanded={(): void => undefined}
            width={width}
            height={height}
            listHeight={height}
            selectedLabel={
                <div className="flex items-center">
                    <IconFile
                        fillColor="secondary-500"
                        addClasses="mr-2"
                        height={20}
                    />
                    {label}
                </div>
            }
            closeOnClickOutside={true}
            handleCloseOnClickOutside={(): void => undefined}
        />
    );
